import type { CSSProperties } from 'react';

interface SkeletonProps {
  w?: number | string;
  h?: number | string;
  r?: number | string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Shimmer placeholder. Pass `w`/`h`/`r` for explicit sizing (new API) or a
 * Tailwind `className` for sizing (legacy call sites) — inline sizing is only
 * applied when a dimension prop is provided, so it never overrides classes.
 */
export function Skeleton({ w, h, r, className, style }: SkeletonProps) {
  const sized: CSSProperties = {};
  if (w !== undefined) sized.width = w;
  if (h !== undefined) sized.height = h;
  if (r !== undefined) sized.borderRadius = r;
  const hasSizing = w !== undefined || h !== undefined;
  return (
    <span
      className={`wb-skel ${className ?? ''}`}
      style={{ display: hasSizing ? 'block' : undefined, ...sized, ...style }}
    />
  );
}

/** Card-shaped placeholder row (list/trip loading states). */
export function SkeletonRow() {
  return (
    <div
      className="wb-card wb-card--pad"
      style={{ display: 'flex', gap: 14, alignItems: 'center' }}
    >
      <Skeleton w={46} h={46} r={14} />
      <div className="wb-grow wb-col wb-gap-8">
        <Skeleton w="60%" h={15} />
        <Skeleton w="38%" h={12} />
      </div>
      <Skeleton w={44} h={20} r={999} />
    </div>
  );
}
